import * as t from './actionTypes';
import {
  IntegrationType,
  MobileApp,
  MobileAppsReducerState,
  TestPushPayload,
  UnassignedIntegrations,
} from './types';

export const DEFAULT_REDUCER_STATE: MobileAppsReducerState = {
  apps: {},
  integrations: {
    unassigned: [],
  } as UnassignedIntegrations,
  integrationsLoadingState: false,
  isFetchingMobileApps: false,
  isFetchingIntegrations: false,
  fetchingMobileAppsError: false,
  fetchingIntegrationsError: false,
  createOrUpdateIntegrationError: false,
  createOrUpdateIntegrationInProgress: false,
};

const mobileAppsReducer = (
  state = DEFAULT_REDUCER_STATE,
  action: {
    type: string;
    integrations?: Record<number, IntegrationType>;
    mobileAppInfo?: MobileApp;
    mobileApps?: Record<number, MobileApp>;
    pushMessage?: TestPushPayload;
  },
) => {
  switch (action.type) {
    case t.FETCH_MOBILE_APPS_REQUEST:
    case t.FETCH_MOBILE_APP_REQUEST:
      return { ...state, isFetchingMobileApps: true };
    case t.FETCH_MOBILE_APPS_RESPONSE:
      return { ...state, isFetchingMobileApps: false, apps: action.mobileApps };
    case t.FETCH_MOBILE_APP_ERROR:
      return { ...state, fetchingMobileAppsError: true };
    case t.FETCH_MOBILE_APP_RESPONSE: {
      const mobileAppInfo = action.mobileAppInfo as MobileApp;
      return {
        ...state,
        isFetchingMobileApps: false,
        apps: {
          ...state.apps,
          [mobileAppInfo.id]: mobileAppInfo,
        },
      };
    }
    case t.DELETE_MOBILE_APP_RESPONSE:
      return {
        ...state,
        apps: {},
      };
    case t.CREATE_INTEGRATION_REQUEST:
    case t.UPDATE_INTEGRATION_REQUEST:
      return {
        ...state,
        createOrUpdateIntegrationInProgress: true,
        createOrUpdateIntegrationError: false,
      };
    case t.FETCH_INTEGRATIONS_REQUEST:
      return { ...state, isFetchingIntegrations: true };
    case t.ASSIGN_INTEGRATION_REQUEST:
    case t.SEND_TEST_PUSH_REQUEST:
      return { ...state, isFetchingIntegrations: true };
    case t.FETCH_INTEGRATIONS_RESPONSE:
      return {
        ...state,
        integrations: action.integrations,
        fetchingIntegrationsError: false,
        isFetchingIntegrations: false,
      };
    case t.CREATE_INTEGRATION_RESPONSE:
    case t.UPDATE_INTEGRATION_RESPONSE:
      return {
        ...state,
        integrations: action.integrations,
        fetchingIntegrationsError: false,
        createOrUpdateIntegrationInProgress: false,
        createOrUpdateIntegrationError: false,
      };
    case t.ASSIGN_INTEGRATION_RESPONSE:
      return {
        ...state,
        fetchingIntegrationsError: false,
        integrations: {
          ...state.integrations,
          unassigned: action.integrations,
        },
      };
    case t.DELETE_INTEGRATION_RESPONSE:
      return {
        ...state,
        integrations: action.integrations,
      };
    case t.CREATE_INTEGRATION_ERROR:
    case t.UPDATE_INTEGRATION_ERROR:
      return {
        ...state,
        integrationsLoadingState: false,
        fetchingIntegrationsError: false,
        isFetchingIntegrations: false,
        createOrUpdateIntegrationInProgress: false,
        createOrUpdateIntegrationError: true,
      };
    case t.SEND_TEST_PUSH_RESPONSE:
    case t.SEND_TEST_PUSH_ERROR:
    case t.ASSIGN_INTEGRATION_ERROR:
      return {
        ...state,
        integrationsLoadingState: false,
        fetchingIntegrationsError: false,
        isFetchingIntegrations: false,
      };
    case t.FETCH_INTEGRATIONS_ERROR:
      return { ...state, integrationsLoadingState: false, fetchingIntegrationsError: true };
    default: {
      return state;
    }
  }
};

export default mobileAppsReducer;
